import { z } from "zod";

export const diagramRevisionSchema = z.string().regex(/^(0|[1-9][0-9]*)$/);
